import { useCallback, useId, useRef, type ReactNode } from 'react';
import { useReward } from 'react-rewards';
import { Box, type BoxProps } from '@/ui';
import { ConfettiContext } from './ConfettiContext';

type Props = BoxProps & {
  children: ReactNode;
};

export const Confetti = ({ children }: Props) => {
  const rewardId = useId();
  const callbackRef = useRef(() => {});

  const { reward } = useReward(rewardId, 'confetti', {
    startVelocity: 20,
    lifetime: 300,
    elementCount: 100,
    spread: 200,
    onAnimationComplete: callbackRef.current,
  });

  const confetti = useCallback(() => {
    reward();
  }, [reward]);

  return (
    <ConfettiContext.Provider value={{ confetti }}>
      <Box
        id={rewardId}
        left="50%"
        pointerEvents="none"
        pos="fixed"
        top="33%"
        zIndex="calc(var(--chakra-zIndices-modal) + 10)"
      />

      {children}
    </ConfettiContext.Provider>
  );
};
